import { Route, Redirect } from "react-router-dom";
import { useAuthInfo } from "../../context/AuthContext";

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  const { userInfo } = useAuthInfo();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (userInfo && restricted) {
          return <Redirect to="/home" />;
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default PublicRoute;
